const task = {
  heading: 'List task',
}

export default task
